import { hostPortFromPortBinding } from '../../scripts/host-port-from-port-binding.js';

/**
 * Local `yarn dev` / `yarn dev:all` listen port (matches `server/dev.mjs` + Vite dev client).
 * Production Docker publish is **`portBinding`** below (host **3010** → container **3000**).
 */
export const devListenPort = 3011;

/** Loopback 3010 → landing SSR (use host nginx on 443 to expose; dashboard stays on host 3000). */
export const appDeployConfig = {
  portBinding: '127.0.0.1:3010:3000',
  memoryLimit: '256m',
  memorySwap: '512m',
  envForwardKeys: [
    'LANDING_REGISTER_URL',
    'LANDING_LOGIN_URL',
    'LANDING_BLOG_URL',
    'LANDING_PUBLIC_URL',
    'BLOG_PUBLIC_URL',
    'FRONTEND_URL',
    'STOCKS_WEB_ORIGIN',
    'EDGE_PUBLIC_DOMAIN',
    'SEO_SITE_NAME',
    'SEO_DEFAULT_OG_IMAGE_PATH',
    'SEO_TWITTER_SITE',
    'SEO_TWITTER_CREATOR',
    'SEO_BING_VERIFICATION',
    'SEO_YANDEX_VERIFICATION',
    'SEO_INDEXNOW_KEY',
    'SEO_ORGANIZATION_SAME_AS',
    'SEO_GTM_CONTAINER_ID',
    'VITE_MIXPANEL_TOKEN',
  ],
};

export const deployListenPort = hostPortFromPortBinding(appDeployConfig.portBinding);
